import React, { useState, useEffect } from "react";
import { Form, Image } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/free-solid-svg-icons";
import AuthUser from "../../components/AuthUser";
import { Apis } from "../../common/Apis";
import { useHistory, useParams } from "react-router-dom";
import { parseError } from "../../common/Utility";
import ErrorMsg from "../../common/ErrorMsg";
import { useSelector } from "react-redux";
import Select from "react-select";

const Update = () => {
    let data = useSelector(state => state.listData);
    if (data.length === 0)
        data = JSON.parse(sessionStorage.getItem("listData"));
    const { id } = useParams();
    const dataSingle = data.filter(obj => obj.id == id);
    const selectedCats = dataSingle[0].category ? dataSingle[0].category.map(obj => ({ value: obj.id, label: obj.name })) : null;
    const selectedArts = dataSingle[0].musicArtists ? dataSingle[0].musicArtists.map(obj => ({ value: obj.uuid, label: obj.name })) : null;

    const { http } = AuthUser();
    const [categories, setCategories] = useState(null);
    const [artists, setArtists] = useState(null);
    const [trackTitle, setTrackTitle] = useState(dataSingle[0].name);
    const [category, setCategory] = useState(selectedCats);
    const [artist, setArtist] = useState(selectedArts);
    const [album, setAlbum] = useState(dataSingle[0].album_name || "");
    const [recordingLabel, setRecordingLabel] = useState(dataSingle[0].label || "");
    const [country, setCountry] = useState(dataSingle[0].country || "");
    const [diskNumber, setDiskNumber] = useState(dataSingle[0].disc_num || "");
    const [trackNumber, setTrackNumber] = useState(dataSingle[0].track_num || "");
    const [BPM, setBPM] = useState(dataSingle[0].bpm || "");
    const [contractID, setContractID] = useState(dataSingle[0].contract_id || "");
    const [externalID, setExternalID] = useState(dataSingle[0].external_id || "");
    const [contactEmail, setContactEmail] = useState(dataSingle[0].contact_email || "");
    const [duration, setDuration] = useState(dataSingle[0].duration || "");
    const [lyricFile, setLyricFile] = useState(dataSingle[0].lyricFile);
    const [artworkCover, setArtworkCover] = useState(null);
    const [previousArtworkCover, setPreviousArtworkCover] = useState(dataSingle[0].img_thumb);
    const [standardFile, setStandardFile] = useState(dataSingle[0].song_url);
    const [File360, setFile360] = useState(dataSingle[0].xr_audio_url);
    const [content, setContent] = useState(dataSingle[0].content || "");
    const [status, setStatus] = useState(dataSingle[0].is_active);
    const [isTop, setIsTop] = useState(dataSingle[0].is_top);
    const [isExplicit, setIsExplicit] = useState(dataSingle[0].is_explicit);
    const [isXR, setIsXR] = useState(dataSingle[0].is_xr);
    const [isVideo, setIsVideo] = useState(dataSingle[0].is_video);
    const [isDolby, setIsDolby] = useState(dataSingle[0].is_dolby);
    const [releaseDate, setReleaseDate] = useState(dataSingle[0].release_date ? dataSingle[0].release_date.slice(0, 10) : "");
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(null);
    const [error, setError] = useState(null);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [deleteError, setDeleteError] = useState(null);
    const [song_playing_type, setSongPlayingType] = useState(dataSingle[0].song_playing_type);
    console.log(song_playing_type);
    const history = useHistory();

    useEffect(() => {
        http.get(Apis.get_all_category)
        .then(res => {
            setCategories(res.data.data);
        });
        http.get(Apis.get_all_artist)
        .then(res => {
            setArtists(res.data.data);
        });
    }, []);

    const loadImage = (e, imgId) => {
        const output = document.getElementById(imgId);
        output.src = URL.createObjectURL(e.target.files[0]);
        output.onload = () => {
          URL.revokeObjectURL(output.src); // free memory
        }
        if (imgId === "img_thumb_preview")
            setArtworkCover(e.target.files[0]);
    }

    const loadAudio = (e, audId, audSrc) => {
        const audio = document.getElementById(audId);
        const source = document.getElementById(audSrc);
        source.src = URL.createObjectURL(e.target.files[0]);
        audio.pause();
        audio.load();
        source.onload = () => {
          URL.revokeObjectURL(source.src); // free memory
        }
        if (audId === "standard_file_preview")
            setStandardFile(e.target.files[0]);
        else if (audId === "360_file_preview")
            setFile360(e.target.files[0]);
    }

    const deleteSong = () => {
        const resp = window.confirm("Do you want to delete this song?");
        if (resp) {
          setDeleteError(null);
          setDeleteLoading(true);
          http.post(Apis.song.delete, {song_uuid: id})
          .then(res => {
            setDeleteLoading(false);
            setTimeout(() => {
              history.goBack();
            }, 500);
          })
          .catch(err => {
            setDeleteLoading(false);
            if (err.response.status === 400) {
              const errorMsg = parseError(err.response.data.error);
              setDeleteError(errorMsg);
            } else {
              setDeleteError([err.response.data.message]);
            }
          });
        }
      }

    const handleUpdate = (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);

        const formData = new FormData();
        formData.append('song_uuid', id);
        formData.append('name', trackTitle);
        for (let i = 0 ; i < category.length ; i++) {        
            formData.append('category[]', category[i].value);
        }
        if (artist) {
            for (let i = 0 ; i < artist.length ; i++) {
                formData.append('artist[]', artist[i].value);
            }
        }
        formData.append('album_name', album);
        formData.append('label', recordingLabel);
        formData.append('country', country);
        formData.append('disc_num', diskNumber);
        formData.append('track_num', trackNumber);
        formData.append('bpm', BPM);
        formData.append('contract_id', contractID);
        formData.append('external_id', externalID);
        formData.append('contact_email', contactEmail);
        formData.append('duration', duration);
        formData.append('lyricFile', lyricFile);
        formData.append('img_thumb', artworkCover);
        formData.append('song_file', standardFile);
        formData.append('xr_audio_file', File360);
        formData.append('content', content);
        formData.append('is_active', status);
        formData.append('is_top', isTop);
        formData.append('is_explicit', isExplicit);
        formData.append('is_video', isVideo);
        formData.append('is_dolby', isDolby);
        formData.append('release_date', releaseDate);
        formData.append('song_playing_type', song_playing_type);
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        };
        
        http.post(Apis.song.update, formData, config)
        .then(res => {
            setLoading(false);
            setSuccess("Song updated successfully!");
            setTimeout(() => {
                history.goBack();
            }, 800);
        })
        .catch(err => {
            setLoading(false);
            if (err.response.status === 400) {
                const errorMsg = parseError(err.response.data.error);
                setError(errorMsg);
            } else {
                setError([err.response.data.message]);
            }
        });
    }

    return (
        <div className="container">
            <div className="row">          
                <div className="col-sm-6 mt-3">
                    <h6 style={{ fontWeight: 'bold' }}><span><FontAwesomeIcon icon={ faList } /></span> UPDATE MUSIC</h6>
                </div>
                <div className="col-sm-6 text-right mt-3">
                    
                </div>
            </div>
            {
              success && <div className="row mt-3">
                            <div className="col">
                                <div className="alert alert-success" style={{padding: '.5rem 1rem'}}>
                                    <strong>Success!</strong> {success}
                                </div>
                            </div>
                        </div>
            }
            {
                error && <ErrorMsg errors={error} />
            }
            {
                deleteError && <ErrorMsg errors={deleteError} />
            }
            <Form className="mt-4" onSubmit={ handleUpdate }>
                <div className="row">
                    <div className="col">
                        <Form.Group id="name" className="mb-4">
                            <Form.Label>Track Title<span style={{ color: "red" }}> *</span></Form.Label>
                            <Form.Control required defaultValue={ trackTitle } onChange={(e) => setTrackTitle(e.target.value)} />
                        </Form.Group>
                    </div>
                    <div className="col">
                        <Form.Group id="category" className="mb-4">
                            <Form.Label>Category<span style={{ color: "red" }}> *</span></Form.Label>
                            <Select
                            required
                            isMulti
                            isSearchable
                            isClearable
                            className="basic-multi-select"
                            classNamePrefix="select"
                            defaultValue={ category }
                            options={ categories }
                            onChange={ setCategory } />
                        </Form.Group>
                    </div>
                    <div className="col">
                        <Form.Group id="artist" className="mb-4">
                            <Form.Label>Artist Name</Form.Label>
                            <Select
                            isMulti
                            isSearchable
                            isClearable
                            className="basic-multi-select"
                            classNamePrefix="select"
                            defaultValue={ artist }
                            options={ artists }
                            onChange={ setArtist } />
                        </Form.Group>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <Form.Group id="album" className="mb-4">
                            <Form.Label>Album Name</Form.Label>
                            <Form.Control defaultValue={ album } onChange={(e) => setAlbum(e.target.value)} />
                        </Form.Group>
                    </div>
                    <div className="col">
                        <Form.Group id="recording_label" className="mb-4">
                            <Form.Label>Recording Label</Form.Label>
                            <Form.Control defaultValue={ recordingLabel } onChange={(e) => setRecordingLabel(e.target.value)} />
                        </Form.Group>
                    </div>
                    <div className="col">
                        <Form.Group id="country" className="mb-4">
                            <Form.Label>Country</Form.Label>
                            <Form.Control defaultValue={ country } onChange={(e) => setCountry(e.target.value)} />
                        </Form.Group>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <Form.Group id="disk_number" className="mb-4">
                            <Form.Label>Disk Number</Form.Label>
                            <Form.Control defaultValue={ diskNumber } onChange={(e) => setDiskNumber(e.target.value)} />
                        </Form.Group>
                    </div>
                    <div className="col">
                        <Form.Group id="track_number" className="mb-4">
                            <Form.Label>Track Number</Form.Label>
                            <Form.Control defaultValue={ trackNumber } onChange={(e) => setTrackNumber(e.target.value)} />
                        </Form.Group>
                    </div>
                    <div className="col">
                        <Form.Group id="bpm" className="mb-4">
                            <Form.Label>BPM</Form.Label>
                            <Form.Control defaultValue={ BPM } onChange={(e) => setBPM(e.target.value)} />
                        </Form.Group>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <Form.Group id="contract_id" className="mb-4">
                            <Form.Label>Contract ID</Form.Label>
                            <Form.Control defaultValue={ contractID } onChange={(e) => setContractID(e.target.value)} />
                        </Form.Group>
                    </div>
                    <div className="col">
                        <Form.Group id="external_id" className="mb-4">
                            <Form.Label>External ID</Form.Label>
                            <Form.Control defaultValue={ externalID } onChange={(e) => setExternalID(e.target.value)} />
                        </Form.Group>
                    </div>
                    <div className="col">
                        <Form.Group id="contact_email" className="mb-4">
                            <Form.Label>Contact Email</Form.Label>
                            <Form.Control defaultValue={ contactEmail } onChange={(e) => setContactEmail(e.target.value)} />
                        </Form.Group>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <Form.Group id="duration" className="mb-4">
                            <Form.Label>Duration(In Seconds)<span style={{ color: "red" }}> *</span></Form.Label>
                            <Form.Control defaultValue={ duration } placeholder="In Seconds" onChange={(e) => setDuration(e.target.value)} />
                        </Form.Group>
                    </div>
                    <div className="col" style={{display : "none"}}>
                        <Form.Group id="lyric_file" className="mb-4">
                            <Form.Label>Lyric File</Form.Label>
                            <Form.Control type="file" onChange={(e) => setLyricFile(e.target.files[0])} />
                        </Form.Group>
                    </div>
                </div>
                <div className="row">                    
                    <div className="col">
                        <Form.Group id="img_thumb" className="mb-4">
                            <Form.Label>Artwork Cover</Form.Label>
                            <div className="jumbotron" style={{minHeight: '300px'}}>
                                <Image id="img_thumb_preview" src={ previousArtworkCover } width="200" alt="Drag & drop files here …" />
                            </div>
                            <Form.Control type="file" accept="image/*" onChange={ (e) => loadImage(e, 'img_thumb_preview') } />
                        </Form.Group>
                    </div>
                    <div className="col">
                        <Form.Group id="standard_file" className="mb-4">
                            <Form.Label>Standard File</Form.Label>
                            <div className="jumbotron" style={{minHeight: '300px'}}>
                                <audio controls id="standard_file_preview">
                                    <source id="standard_file_preview_src" src={ standardFile } />
                                </audio>
                            </div>
                            <Form.Control type="file" accept="audio/*" onChange={ (e) => loadAudio(e, 'standard_file_preview', 'standard_file_preview_src') } />
                        </Form.Group>
                    </div>
                    <div className="col">
                        <Form.Group id="360_file" className="mb-4">
                            <Form.Label>360 File</Form.Label>
                            <div className="jumbotron" style={{minHeight: '300px'}}>
                                <audio controls id="360_file_preview">
                                    <source id="360_file_preview_src" src={ File360 } />
                                </audio>
                            </div>
                            <Form.Control type="file" accept="audio/*" onChange={ (e) => loadAudio(e, '360_file_preview', '360_file_preview_src') } />
                        </Form.Group>
                    </div>
                </div>
                <div className="row">                    
                    <div className="col">
                        <Form.Group id="content" className="mb-4">
                            <Form.Label>Content</Form.Label>
                            <Form.Control as="textarea" rows="15" defaultValue={ content } onChange={(e) => setContent(e.target.value)} />
                        </Form.Group>
                    </div>
                    <div className="col">
                        <Form.Group id="is_360_audio" className="mb-4">
                            <Form.Label>Is 360 Audio</Form.Label><br />
                            <span style={{ cursor: 'pointer' }}>
                                <div className="d-inline-block me-1">OFF</div>
                                <div className="form-check form-switch d-inline-block">
                                    <input type="checkbox" className="form-check-input" id="is_360_audio_toggle" defaultChecked={ isXR === 1 && isVideo === 0 ? true : false } style={{ cursor: 'pointer' }} />
                                    <label htmlFor="is_360_audio_toggle" className="form-check-label">ON</label>
                                </div>
                            </span>
                        </Form.Group>
                        <Form.Group id="is_active" className="mb-4">
                            <Form.Label>Is Active</Form.Label><br />
                            <span style={{ cursor: 'pointer' }}>
                                <div className="d-inline-block me-1">OFF</div>
                                <div className="form-check form-switch d-inline-block">
                                    <input type="checkbox" className="form-check-input" id="is_active_toggle" defaultChecked={ status } onChange={ (e) => setStatus(e.target.checked ? "1" : "0") } style={{ cursor: 'pointer' }} />
                                    <label htmlFor="is_active_toggle" className="form-check-label">ON</label>
                                </div>
                            </span>
                        </Form.Group>
                        <Form.Group id="is_top" className="mb-4">
                            <Form.Label>Is Top</Form.Label><br />
                            <span style={{ cursor: 'pointer' }}>
                                <div className="d-inline-block me-1">OFF</div>
                                <div className="form-check form-switch d-inline-block">
                                    <input type="checkbox" className="form-check-input" id="is_top_toggle" defaultChecked={ isTop } onChange={ (e) => setIsTop(e.target.checked ? "1" : "0") } style={{ cursor: 'pointer' }} />
                                    <label htmlFor="is_top_toggle" className="form-check-label">ON</label>
                                </div>
                            </span>
                        </Form.Group>
                        <Form.Group id="is_explicit" className="mb-4">
                            <Form.Label>Is Explicit</Form.Label><br />
                            <span style={{ cursor: 'pointer' }}>
                                <div className="d-inline-block me-1">OFF</div>
                                <div className="form-check form-switch d-inline-block">
                                    <input type="checkbox" className="form-check-input" id="is_explicit_toggle" defaultChecked={ isExplicit } onChange={ (e) => setIsExplicit(e.target.checked ? "1" : "0") } style={{ cursor: 'pointer' }} />
                                    <label htmlFor="is_explicit_toggle" className="form-check-label">ON</label>
                                </div>
                            </span>
                        </Form.Group>
                        <Form.Group id="is_video" className="mb-4">
                            <Form.Label>Is Video</Form.Label><br />
                            <span style={{ cursor: 'pointer' }}>
                                <div className="d-inline-block me-1">OFF</div>
                                <div className="form-check form-switch d-inline-block">
                                    <input type="checkbox" className="form-check-input" id="is_video_toggle" defaultChecked={ isVideo } onChange={ (e) => setIsVideo(e.target.checked ? "1" : "0") } style={{ cursor: 'pointer' }} />
                                    <label htmlFor="is_video_toggle" className="form-check-label">ON</label>
                                </div>
                            </span>
                        </Form.Group>
                        <Form.Group id="is_dolby" className="mb-4">
                            <Form.Label>Is Dolby</Form.Label><br />
                            <span style={{ cursor: 'pointer' }}>
                                <div className="d-inline-block me-1">OFF</div>
                                <div className="form-check form-switch d-inline-block">
                                    <input type="checkbox" className="form-check-input" id="is_dolby_toggle" defaultChecked={ isDolby } onChange={ (e) => setIsDolby(e.target.checked ? "1" : "0") } style={{ cursor: 'pointer' }} />
                                    <label htmlFor="is_dolby_toggle" className="form-check-label">ON</label>
                                </div>
                            </span>
                        </Form.Group>
                        <Form.Group id="release_date" className="mb-4">
                            <Form.Label>Release Date</Form.Label>
                            <Form.Control type="date" defaultValue={ releaseDate } onChange={(e) => setReleaseDate(e.target.value)} />
                        </Form.Group>
                        <Form.Group id="song" className="mb-4">
                            <Form.Label>Song Playing Type<span style={{ color: "red" }}>*</span></Form.Label>
                            <Form.Control as="select" value={song_playing_type} onChange={(e) => setSongPlayingType(e.target.value)}>
                                <option value="for_radio">For Radio</option>
                                <option value="for_playlist">For Playlist</option>
                                <option value="both">Both</option>
                            </Form.Control>
                        </Form.Group>
                    </div>
                </div>

                <button className="btn cust-button" style={{ backgroundColor: '#36c6d3', borderColor: '#2bb8c4', color: '#fff', fontSize: '12px', fontWeight: 'bold' }} disabled={loading}>
                    UPDATE {loading && <span className="spinner-border spinner-border-sm" style={{marginLeft: '5px', width: '1rem', height: '1rem', verticalAlign: 'middle', animation: '1s linear infinite spinner-border'}}></span>}
                </button>
                <button type="button" className="btn btn-danger ms-1" style={{ fontSize: '12px', fontWeight: 'bold' }} onClick={ deleteSong }>
                    DELETE {deleteLoading && <span className="spinner-border spinner-border-sm" style={{marginLeft: '5px', width: '1rem', height: '1rem', verticalAlign: 'middle', animation: '1s linear infinite spinner-border'}}></span>}
                </button>
                <button type="button" className="btn btn-default ms-1" style={{ backgroundColor: '#eee', border: '1px solid #ccc', fontSize: '12px', fontWeight: 'bold' }} onClick={ () => history.goBack() }>CANCEL</button>
            </Form>
        </div>
    );
}
export default Update;